/**
 * What a role may do, in the order the API enforces it (TASKS.md B3): `VIEW`
 * reads, `EDIT` also mutates business entities, `ADMIN` also manages accounts
 * and reads the audit trail.
 *
 * Pure and table-driven so the UI cannot drift from the server's ordering — the
 * api still answers 403 if these helpers ever disagree with it. This is about
 * not drawing a button that would only produce an error. Deliberately free of
 * imports: it is unit-tested outside Vite, where `import.meta.env` does not
 * exist.
 */
import type { AppRole } from '../api/types';

export type { AppRole };

const RANK: Record<AppRole, number> = { VIEW: 1, EDIT: 2, ADMIN: 3 };

export type Capability = 'read' | 'edit' | 'admin';

export function roleAllows(role: AppRole | null | undefined, needed: Capability): boolean {
  if (needed === 'read') return role !== null && role !== undefined;
  if (!role) return false;
  return RANK[role] >= RANK[needed === 'edit' ? 'EDIT' : 'ADMIN'];
}
